import { h, defineComponent, SetupContext } from 'vue';
import { ValidationError } from '@/entities/validation';
import { SelectOptions, SetterCallback } from '@/ui/types';
import { Field, FieldProps } from './Field';
import { Dropdown, DropdownProps } from '../controls/Dropdown';

export interface DropdownFieldProps<T = number> {
  name: string;
  label: string;
  value: T | null;
  required: boolean;
  placeholder: string;
  disabled: boolean;
  options: SelectOptions<T>;
  errors: ValidationError[];
  scrollable?: boolean;
  maxHeight?: number;
  isGrayText?: boolean;
  hideLabel?: boolean;
  horizontal?: boolean;
  tooltipText?: string;
  appendToBody?: boolean;
}

export const DropdownField = defineComponent<DropdownFieldProps>({
  name: 'DropdownField',

  props: [
    'name', 'label', 'value', 'required', 'placeholder', 'options', 'errors', 'disabled',
    'scrollable', 'maxHeight', 'isGrayText', 'hideLabel', 'horizontal', 'tooltipText', 'appendToBody',
  ],
  setup(props, context: SetupContext) {
    return function render() {
      const fieldProps: FieldProps = {
        label: props.label,
        name: props.name,
        required: props.required,
        errors: props.errors,
        hideLabel: props.hideLabel,
        horizontal: props.horizontal,
        disabled: props.disabled,
        tooltipText: props.tooltipText,
      };

      const dropdownProps: DropdownProps<number> = {
        value: props.value,
        options: props.options,
        disabled: props.disabled,
        placeholder: props.placeholder,
        scrollable: props.scrollable,
        maxHeight: props.maxHeight,
        isGrayText: props.isGrayText,
        appendToBody: props.appendToBody ?? false,
      };

      return h(Field, { props: fieldProps }, [
        h(Dropdown, {
          props: dropdownProps,
          on: {
            input: (value: unknown) => {
              context.emit('input', value);
            },
          },
        }),
      ]);
    };
  },
});

export function dropdownField<T = number>(props: DropdownFieldProps<T>, input: SetterCallback<T>) {
  return h(DropdownField, {
    props,
    on: { input },
  });
}
